import {Component, inject} from '@angular/core';
import {RoutesService} from '@raven';
import {BranchSelectors, OrganizationSelectors, PatronSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-catalog-footer',
  templateUrl: './catalog-footer.component.html',
  styleUrl: './catalog-footer.component.scss',
  standalone: false
})
export class CatalogFooterComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly branchSelectors = BranchSelectors.Auth;
  public readonly routingService = inject(RoutesService);
  public readonly currentYear = (new Date().getFullYear()).toString();
}
